// import Cookies from "js-cookie"
import { del, get, post, put } from "../apiWrapper";
import {
  actionInterface,
  
  callApiActionInterface,
  copyClipboardInterface,
  dynamicPayload,
  redirectActionInterface,
  scrollActionInterface,
  updateCookieInterface,
  updateLocalStorageActionInterface,
  updateReduxStateActionInterface,
  updateState,
  updateStateActionInterface,
  validateInput,
  validateInputFieldsInterface,
} from "./actionInterface";
import getData from "../getData";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { replacePlaceholders } from "@/utils/pathMatcher";
import { useCallback, useEffect, useRef, useState } from "react";
import useConditions from "../verifyConditions";
import { clearAllCookies, deleteCookie, getCookie, setCookie } from "../clientStorageActions";
import performOperations from "@/utils/performOperations";
import performArrayOperations from "@/utils/performArrayOperations";
import { trackGA4Event } from "@/app/config/ga4";
import { deviceRegisterApi } from "../deviceRegisterApi";
import useCountDown from "@/utils/useCountDowns";
import { globalRegex } from "@/utils/constants";
import { trackEvent } from "@/app/config/mixpanel";
import { useAppState } from "@/context/AppStateContext";
import { debounceInstace } from "../debounce";
import { getIdentifier } from "../api";

const useAction = (
  globalState: any,
  fullGlobalState: any,
  setGlobalState: Function,
  locale?:string
) => {
  const router = useRouter();
  const {dispatch, state: {layoutStore, pageStore}} = useAppState();
  const searchParams = useSearchParams();
  const pathname = usePathname()
  const { start } = useCountDown();
  const verifyConditions = useConditions(
    globalState,
  );

  const timersRef = useRef<NodeJS.Timeout[]>([]);
  const addTimer = (timer: NodeJS.Timeout) => {
    timersRef.current.push(timer);
    return timer;
  };
  useEffect(() => {
    return () => {
      timersRef.current.forEach(timer => clearTimeout(timer));
      timersRef.current = [];
    };
  }, []);

  const callAction = useCallback(
    async (action: actionInterface, payload?: any) => {
      if (verifyConditions(action.conditions ?? [], payload, payload ? payload : globalState,fullGlobalState)){
        switch (action.actionType) {
          case "callApi":
            setTimeout(async()=>{
              if((action?.isAuthenticationRequired ?? false) && (getCookie("accessToken") === "" || getCookie("accessToken") === undefined || getCookie("accessToken") === null)){
                return;
              }else{
                callApi(
                  action,
                  action?.requireEventValue
                    ? globalState
                    : payload
                      ? payload
                      : ""
                );
              }
            },0)
            break;
          case "updateState":
            updateGlobalState(
              action,
              action?.requireEventValue
                ? globalState
                : payload !== undefined
                  ? payload
                  : globalState
            );
            break;
          case "redirect":
            redirect(action, payload ? payload : globalState, globalState);
            break;
          case "updateReduxState":
            updateReduxState(action, payload);
            break;
          case "updateLocalStorage":
            updateLocalStorage(action, payload);
            break;
          case "cookieOperation":
            cookieOperations(action, payload)
            break;
          case "scrollIntoView":
            scrollIntoView(action, payload)
            break;
          case "copyClipboard":
            copyToClipboard(action, payload)
            break;
          case "openChat":
            // @ts-ignore
            if(typeof window !== 'undefined' && window.fcWidget !== "undefined"){
              // @ts-ignore
              window.fcWidget?.show();
              // @ts-ignore
              window.fcWidget?.open();
            }
            break;
          case "setUserLocation":
            navigator.geolocation.getCurrentPosition(
              (location)=>{
                updateReduxState( {
                  "actionType": "updateReduxState",
                  "reducer":"layout",
                  "update": {
                    "key": "userLocation"
                  }
                }, location);
                // for (let i = 0; i < action.onSuccess?.length; i++) {
                //   callAction(action.onSuccess?.[i],{latitude:location.coords.latitude,longitude:location.coords.longitude,...payload});
                // }
                if (Array.isArray(action.onSuccess)) {
                  action.onSuccess.forEach((successAction) => {
                    Promise.resolve().then(() => {
                      callAction(successAction, {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude,
                        ...payload,
                      });
                    });
                  });
                }
              },
              (error)=>{
                // for (let i = 0; i < action.onError?.length; i++) {
                //   callAction(action.onError?.[i],{...error});
                // }
                if (Array.isArray(action.onError)) {
                  action.onError.forEach((errorAction) => {
                    Promise.resolve().then(() => {
                      callAction(errorAction, { ...error });
                    });
                  });
                }
              }
            )
            break;
          case "ga4":
            setTimeout(async() => {
              const eventProperties: any = {
                ...(layoutStore?.profile?.id && { user_id: layoutStore.profile.id }),
                user_state: getCookie("accessToken") ? "logged_in" : "guest",
                mk_identifier: getCookie("deviceId") ?? null
              };
              await Object.entries(action?.properties ?? {})?.map(
                async ([key, valueObj]: any) => {
                  const valueState =
                    valueObj?.source === "REDUX"
                      ? { page: pageStore, layout: layoutStore }
                      : valueObj?.source === "GLOBAL"
                      ? fullGlobalState
                      : valueObj?.source === "DEFAULT"
                      ? payload
                      : globalState;
                  const value = typeof valueObj !== "object" ? valueObj : await getData(
                    valueObj ?? {},
                    valueState,
                    globalState,
                    fullGlobalState,
                    { page: pageStore, layout: layoutStore },
                    payload
                  );
                  eventProperties[key] = value;
                }
              );
              trackGA4Event(action?.eventName, eventProperties);
            },0);
            break;
          case "meta-pixel":
            setTimeout(async() => {
              const eventProperties: any = {
                ...(layoutStore?.profile?.id && { user_id: layoutStore.profile.id }),
                user_state: getCookie("accessToken") ? "logged_in" : "guest",
                mk_identifier: getCookie("deviceId") ?? null
              };
              await Object.entries(action?.properties ?? {})?.map(
                async ([key, valueObj]: any) => {
                  const valueState =
                    valueObj?.source === "REDUX"
                      ? { page: pageStore, layout: layoutStore }
                      : valueObj?.source === "GLOBAL"
                      ? fullGlobalState
                      : valueObj?.source === "DEFAULT"
                      ? payload
                      : globalState;
                  const value = typeof valueObj !== "object" ? valueObj : await getData(
                    valueObj ?? {},
                    valueState,
                    globalState,
                    fullGlobalState,
                    { page: pageStore, layout: layoutStore },
                    payload
                  );
                  eventProperties[key] = value;
                }
              );
              //trackGA4Event(action?.eventName, eventProperties);
              console.log("fbq", action?.eventName, eventProperties);
              //ignoreing the type error for fbq as it is a global function provided by the Meta Pixel script
              // @ts-ignore
              fbq('trackCustom', action?.eventName, eventProperties);
            },10);
            break;
          case "mixpanel":
            setTimeout(async() => {
              const mixpanelEventProperties: any = {};
              await Object.entries(action?.properties ?? {})?.map(
                async ([key, valueObj]: any) => {
                  const valueState =
                    valueObj?.source === "REDUX"
                      ? { page: pageStore, layout: layoutStore }
                      : valueObj?.source === "GLOBAL"
                      ? fullGlobalState
                      : valueObj?.source === "DEFAULT"
                      ? payload
                      : globalState;
                  const value = typeof valueObj !== "object" ? valueObj : await getData(
                    valueObj ?? {},
                    valueState,
                    globalState,
                    fullGlobalState,
                    { page: pageStore, layout: layoutStore },
                    payload
                  );
                  mixpanelEventProperties[key] = value;
                }
              );
              trackEvent(action?.eventName, mixpanelEventProperties);
            },0);
          break;
          case "focus":
            let elem:any;
            if(action.selectType === "class"){
              elem = document.getElementsByClassName(action.class??"")
            }else{              
              elem =document.getElementById(action.id?? '')
            }
            
            if(elem){
              elem.focus();
            }
            break;
          case "print":
            let selectedContent = "";

            if (action.selectType === "class") {
              const elements = document.getElementsByClassName(action.class ?? "");
              if (elements.length > 0) {
                selectedContent = Array.from(elements)
                  .map((el) => {
                    el.classList.remove("d-none"); 
                    return el.outerHTML;
                  })
                  .join("");
              }
            } else {
              const element = document.getElementById(action.id ?? "");
              if (element) {
                element.classList.remove("d-none"); 
                selectedContent = element.outerHTML;
              }
            }

            if (selectedContent) {
              requestAnimationFrame(() => {
                const printWindow = window.open("", "", "width=800,height=600");

                if (printWindow) {
                  printWindow.document.write(`
                    <html>
                      <head>
                        <title>Print Compare medicines</title>
                        <style>
                          * {
                            box-sizing: border-box;
                            margin: 0;
                            padding: 0;
                          }
                          body {
                            font-family: Arial, sans-serif;
                            padding: 20px;
                            box-sizing: border-box;
                            margin: 20px;
                            padding: 0;
                          }
                        </style>
                      </head>
                      <body>
                        ${selectedContent}
                      </body>
                    </html>
                  `);
                  printWindow.document.close();

                  // Wait for content to render before printing
                    printWindow.onload = () => {
                    printWindow.focus();
                    printWindow.print();

                    setTimeout(() => {
                      if (!printWindow.closed) {
                        printWindow.close();
                      }
                    }, 100);

                    // Restore hidden elements when window is closed
                    const restoreHiddenContent = () => {
                      if (action.selectType === "class") {
                        Array.from(document.getElementsByClassName(action.class ?? "")).forEach((el) =>
                          el.classList.add("d-none")
                        );
                      } else {
                        const el = document.getElementById(action.id ?? "");
                        if (el) el.classList.add("d-none");
                      }
                    };

                    // Handle window closed by user
                    const checkClose = setInterval(() => {
                      if (printWindow.closed) {
                        restoreHiddenContent();
                        clearInterval(checkClose);
                      }
                    }, 500);

                    printWindow.addEventListener("beforeunload", restoreHiddenContent);
                  };
                }
              });
            };
            break;
          case "share":
            setTimeout(async()=>{
                navigator.share({
                title:action.title,
                text:action.text,
                url: typeof action.url === "string" ? action.url : getData(action.url,action.url.source === "GLOBAL" ? fullGlobalState : action.url.source === "REDUX" ? {page:pageStore,layout:layoutStore} : payload,globalState,fullGlobalState,{page:pageStore,layout:layoutStore},payload)
              }).then(()=>{
                
              }).catch((error)=>{
              })
            },0);
            break;
          case "setCountdown":
            start(action?.counter,action.key,()=>{
              for (let i = 0; i < action.actionsAfterStateUpdate?.length; i++) {
                callAction(action.actionsAfterStateUpdate?.[i],globalState);
              }
            });
            break;
          case "validateInputFields":
            validateInputFields(action, payload)
            break;
          case "redirectBack":
            router.back();
            break;
          case "updateQueryParams":
            const paramsObj: Record<string, string> = {};
            searchParams.forEach((value, key) => {
              paramsObj[key] = value;
            });
            await Promise.all(
              Object.entries(action?.updateParams ?? {}).map(async ([key, valueObj]) => {
                const valueState =
                  valueObj?.source === "REDUX"
                    ? { page: pageStore, layout: layoutStore }
                    : valueObj?.source === "GLOBAL"
                    ? fullGlobalState
                    : valueObj?.source === "DEFAULT"
                    ? payload
                    : globalState;

                const value =
                  typeof valueObj !== "object"
                    ? valueObj
                    : await getData(
                        valueObj ?? {},
                        valueState,
                        globalState,
                        fullGlobalState,
                        { page: pageStore, layout: layoutStore },
                        payload
                      );

                if (value === null || value === undefined) {
                  delete paramsObj[key];
                } else {
                  paramsObj[key] = value;
                }
              })
            );
            const updatedSearch = new URLSearchParams(paramsObj).toString();
            requestAnimationFrame(() => {
              router.replace(`?${updatedSearch}`);
            });
            break;
          //@ts-ignore
          case "fetchApiAndDownload":
            fetchApiAndDownload(action, payload);
            
          default:
            break;
        }
      }
    },
    [globalState, pageStore, layoutStore, router, searchParams, pathname]
  );

  const fetchApiAndDownload = async (action: any, payload: any) => {
    const apiBase = action?.baseUrl || process.env.NEXT_PUBLIC_API_BASE_URL || "";
    const identifier = await getIdentifier();
    if (!identifier || !identifier.trim()) {
      dispatch({
        type: "SET_REDUX_STATE", payload: {
          action: {
            actionType: "updateReduxState",
            reducer: "layout",
            update: {
              key: "toaster",
              field: {
                key: "type"
              }
            }
          },
          payload: "error",
        }
      })
      dispatch(
        {
          type: "SET_REDUX_STATE", payload: {
            action: {
              actionType: "updateReduxState",
              reducer: "layout",
              update: {
                key: "toaster",
                field: {
                  key: "message"
                }
              }
            },
            payload: "Missing identifier",
          }
        }
      )
      return;
    }

    const res = await fetch(apiBase + action?.endpoint + `?identifier=${identifier}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + getCookie("accessToken")
      },
      method: action?.method,
      body: action?.method !== "GET" ? JSON.stringify(getPayload(action, action?.requireEventValue
        ? globalState
        : payload
          ? payload
          : "")) : undefined
    });
    const blob = await res.blob();

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = "prescription.jpg";
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  }

  const validateInputFields = async(action:validateInputFieldsInterface,payload:any) =>{
    if(action?.fields.length > 0){
      let errors:any = {};
      action.fields.forEach((field:validateInput)=>{
        const inputValue = getData(field.value,payload,globalState,fullGlobalState,  { page: pageStore, layout: layoutStore },payload)
        
        if(field.is_required){
          if(inputValue === undefined || inputValue === null || inputValue === ""){
            let name = field.name.replace("_"," ");
            errors[field.name] = (name.charAt(0).toUpperCase() + name.slice(1,name.length)) + " is Required";
          }
        }
        if(!errors[field.name]){
          const regexPattern = globalRegex[field.regex ?? ""] ??  field.regex;
          const regex = new RegExp(regexPattern);
          if(!regex.test(inputValue)){
            errors[field.name] = field.errorMessage ?? "Invalid value";
          }
        }
      });
      
      setGlobalState((prevState:any) =>{
        prevState.inputErrors = Object.keys(errors).length > 0 ? errors : null;
        const newState = {...prevState ?? {}};
        setTimeout(() => {
          if (action?.actionsAfterStateUpdate && action?.actionsAfterStateUpdate?.length > 0) {
            for (let i = 0; i < action.actionsAfterStateUpdate?.length; i++) {
              callAction(action.actionsAfterStateUpdate?.[i], newState);
            }
          }
        }, 0)
        return newState
      })
    }
  }
  
  const cookieOperations = (action: updateCookieInterface, payload: any) => {
    const storeValue = action?.value
      ? action?.value
      : action?.getDynamicValueStructur
      ? getData(
          action?.getDynamicValueStructur,
          payload,
          globalState,
          fullGlobalState,
          { page: pageStore, layout: layoutStore },
          payload
        )
      : "";
   
      
      if (action?.operation === "SET") {
   
      setCookie(action?.key, storeValue)
    } else if (action?.operation === "REMOVE") {
      deleteCookie(action?.key)
    }
  };

  const redirect = (
    action: redirectActionInterface,
    state: any,
    globalState: any
  ) => {
    try {
    let constructedUrl = "";
    let queryParams: string = "";
    if(action?.url === "/" || action?.url === "/home"){

      constructedUrl = "/home"
    }
    else{
      let dynamicValues:any = {};
      action?.url?.split("/")?.map((urlPart, index:number) => {
        if (urlPart?.startsWith("[") && urlPart?.endsWith("]")) {
          const obtainedUrlPart = getData(
            action?.dyanmicUrlMapping?.[urlPart?.slice(1, urlPart?.length - 1)],
            action?.urlMappingSource === "GLOBAL" ? globalState : state
          );
          const key = urlPart.replace("[","").replace("]","");
          dynamicValues[key] = obtainedUrlPart
          // for first value as dynamic slug i have to bypass the leading / in the url formation
          // constructedUrl = index !== 1 ? constructedUrl?.concat("/", obtainedUrlPart) : obtainedUrlPart;
        } 
        // else {
        //   if (urlPart?.length)
        //     constructedUrl = constructedUrl?.concat("/", urlPart);
        // }
      });
      constructedUrl = action?.url?.replace(/\[(\w+)\]/g, (_, key) => dynamicValues[key] ?? "");
      
      if(constructedUrl.includes("?")){
        constructedUrl = constructedUrl.split("?")[0];
      }
      
      if (action?.queryParams) {
        Object?.keys(action?.queryParams).map((key: string, i: number) => {
          const value = action?.queryParams?.[key]?.staticValue
          ? action?.queryParams?.[key]?.staticValue
          : getData(
            action?.queryParams?.[key],
            action?.queryParams?.[key]?.source === "GLOBAL"
            ? globalState
            : state
          );
          if (value) {
            queryParams =
            queryParams !== "" &&
            queryParams.charAt(queryParams.length - 1) !== "&"
            ? queryParams.concat("&")
            : queryParams;
            queryParams = queryParams.concat(key + "=" + value);
          }
        });
        constructedUrl = constructedUrl.concat(`?${queryParams}`)
      }    
    }
    if(locale && locale !== "en" && action?.target !== "_blank"){
      constructedUrl = "/" + locale  + constructedUrl
    }
    router?.push(constructedUrl);
    }catch(err){}
  };

  const scrollIntoView = (action:scrollActionInterface, state:any) => {
    const targetId = action?.dynamicId ? getData(action?.dynamicId, state) : action?.id ? action?.id : null;
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - action?.topOffset,
        behavior: "smooth",
      });
    }
  };
  

  const updateGlobalState =  (
    action: updateStateActionInterface,
    payload: any
  ) => {
   
    const updateState = (
      state: any,
      hierarchy: updateState,
      updatedPayload: any
    ) => {
      const { key, field, index, arrayActions, fieldInArray, operations, dynamicKey } = hierarchy;
      let stateData = {};
      if (dynamicKey?.source) {
        switch (dynamicKey?.source) {
          case "REDUX":
            stateData = { page: pageStore, layout: layoutStore };
            break;
          case "DEFAULT":
            stateData = payload;
            break;
          default:
            stateData = globalState;
        }
      }
      const dynamicKeyValue = getData(
        dynamicKey ?? { key: "" },
        stateData,
        globalState,
        fullGlobalState,
        { page: pageStore, layout: layoutStore }
      );
      if (Array.isArray(state[dynamicKeyValue ?? key]) || (arrayActions && arrayActions?.length > 0)) {
        if (index !== undefined) {
          let extractedIndex = index;
          if (typeof index === "object") {
            // @ts-ignore
            const payloadData = index?.source === "GLOBAL" ? fullGlobalState : payload
            extractedIndex = getData(index, payloadData);
          }
      
          if (!field) {
            state[dynamicKeyValue ?? key][extractedIndex] = operations
              ? performOperations(updatedPayload, operations, globalState)
              : updatedPayload;
            return state;
          }
      
          state[dynamicKeyValue ?? key][extractedIndex] = updateState(
            state[dynamicKeyValue ?? key][extractedIndex],
            field,
            updatedPayload
          );
          return state;
        } else if (arrayActions?.length) {
          state[key] = performArrayOperations(state[key] ?? [],arrayActions, updatedPayload, payload);
          return state;
        }
      }
      if (!field) {
        const keyToUpdate = dynamicKeyValue ?? key;
        const isArray = Array.isArray(updatedPayload);
        
        if (isArray && index !== undefined) {
            state[keyToUpdate] = operations 
                ? performOperations(updatedPayload[index], operations, globalState) 
                : updatedPayload[index];
        } else if (operations) {
            state[keyToUpdate] = performOperations(updatedPayload[key], operations, globalState);
        } else if (updatedPayload && typeof updatedPayload === "object") {
            state[keyToUpdate] = isArray ? [...updatedPayload] : { ...updatedPayload };
        } else {
            state[keyToUpdate] = updatedPayload;
        }
        return state;
    }
    

      if (!state[dynamicKeyValue??key]) {
        state[dynamicKeyValue??key] = {};
      }
      
      state[dynamicKeyValue??key] = updateState(state[dynamicKeyValue??key], field, updatedPayload);
      return state;
    };

    const getResolvedData = (prevState: any) => {
      if (action?.getDynamicValueStructur) {
        const state =
          action?.getDynamicValueStructur.source === "REDUX"
            ? { page: pageStore, layout: layoutStore }
            : action?.getDynamicValueStructur.source === "GLOBAL"
              ? globalState
              : action?.getDynamicValueStructur.source === "DEFAULT"
                ? payload
                : prevState;
        switch (action?.storeType) {
          case "length":
            return getData(action?.getDynamicValueStructur, state, globalState, fullGlobalState, { page: pageStore, layout: layoutStore }, payload)?.length;
          case "negation":
            return !getData(action?.getDynamicValueStructur, state, globalState, fullGlobalState, { page: pageStore, layout: layoutStore }, payload);
          default:
            return getData(action?.getDynamicValueStructur, state, globalState, fullGlobalState, { page: pageStore, layout: layoutStore },payload);
        }
      } else if (action?.getDynamicValueFromResponseStructure) {
        const state =
          action?.getDynamicValueFromResponseStructure.source === "REDUX"
            ? { page: pageStore, layout: layoutStore }
            : action?.getDynamicValueFromResponseStructure.source === "GLOBAL"
              ? globalState
              : action?.getDynamicValueFromResponseStructure.source === "DEFAULT"
                ? payload
                : prevState;

        switch (action?.storeType) {
          case "length":
            return getData(action?.getDynamicValueFromResponseStructure, state, globalState, fullGlobalState, { page: pageStore, layout: layoutStore }, payload)
              ?.length;
          case "negation":
            return !getData(action?.getDynamicValueFromResponseStructure, state, globalState, fullGlobalState, { page: pageStore, layout: layoutStore }, payload);
          default:
            return getData(action?.getDynamicValueFromResponseStructure, state, globalState, fullGlobalState, { page: pageStore, layout: layoutStore }, payload);
        }
      }
    };

    const hierarchy = action?.update;

    if (hierarchy) {
      try {
        setGlobalState((prevState: any) => {
          const dynamicValue = getResolvedData(prevState);
          const updatedPayload = action?.hasOwnProperty("value")
            ? action.value
            : (action?.getDynamicValueStructur ||
              action?.getDynamicValueFromResponseStructure)
              ? dynamicValue
              : payload;
              if(hierarchy?.index === 0){
                
              }
              let newState = { ...(prevState ?? {}) };

              updateState(newState, hierarchy, updatedPayload);
              
              if(action?.actionsAfterStateUpdate && action?.actionsAfterStateUpdate?.length > 0){
                for (let i = 0; i < action.actionsAfterStateUpdate?.length; i++) {
                  // @ts-ignore
                  const { debounce: { id, time = 0 } = {} } = action.actionsAfterStateUpdate[i];
                    if(time){
                      const debounceCallAction = debounceInstace(callAction, time ?? 0, id);
                      debounceCallAction(action.actionsAfterStateUpdate[i], newState);
                    } else {
                      callAction(action.actionsAfterStateUpdate[i], newState)
                    }
                }
              }

          return newState;
        });
      } catch (err) {}
    }
  };

  const updateReduxState = async(
    action: updateReduxStateActionInterface,
    payload: any
  ) => {
    if(action && Number(action?.timeout ?? 0) > 0){
      await new Promise(resolve => setTimeout(resolve, action?.timeout));
    }
    if (action?.reducer === "layout") {  
      const layoutState = layoutStore;
      let resolvedPayload =
        action?.value !== undefined
          ? action.value
          : action?.getDynamicValueStructur
            ? getData(action?.getDynamicValueStructur, layoutState, globalState, fullGlobalState, {page:pageStore, layout: layoutState}, payload)
            : action?.getDynamicValueFromResponseStructure ? getData(action.getDynamicValueFromResponseStructure,payload, globalState, fullGlobalState, {page:pageStore, layout: layoutState}, payload) : payload;

      switch (action?.storeType) {
        case "length":
          resolvedPayload = resolvedPayload?.length;
          break;
        case "negation":
          resolvedPayload = !resolvedPayload;
          break;
        default:
      }
      const reduxActionPayload = { action: action, payload: resolvedPayload, state: payload, fullGlobalState, globalState };
      dispatch({
        type: "SET_REDUX_STATE",
        payload: reduxActionPayload
      });

      new Promise((resolve) => setTimeout(resolve, 0));
    } else {
      const pageReduxState = pageStore;
      const resolvedPayload =
        action?.value !== undefined
          ? action.value
          : action?.getDynamicValueStructur
            ? getData(action?.getDynamicValueStructur, pageReduxState)
            : action?.getDynamicValueFromResponseStructure ? getData(action.getDynamicValueFromResponseStructure,payload) : payload;
      const reduxActionPayload = { action: action, payload: resolvedPayload };
      dispatch({
        type: "SET_REDUX_STATE",
        payload: reduxActionPayload
      });
    }
  };

  const updateLocalStorage = (
    action: updateLocalStorageActionInterface,
    payload: any
  ) => {
    const reduxState = { page: pageStore, layout: layoutStore };
    const updatedPayload = action?.value
      ? action.value
      : action?.getDynamicValueStructur
        ? getData(
          action.getDynamicValueStructur,
          action.getDynamicValueStructur.source === "REDUX"
            ? reduxState
            : globalState
        )
        : action?.getDynamicValueFromResponseStructure
          ? getData(
            action?.getDynamicValueFromResponseStructure,
            action?.getDynamicValueFromResponseStructure?.source === "REDUX"
              ? reduxState
              : payload
          )
          : payload;
          
    typeof window !== "undefined" && localStorage.setItem(action.key, action?.stringify ? JSON.stringify(updatedPayload): updatedPayload);
  }

  const copyToClipboard = async (action: copyClipboardInterface, state:any) =>{
    try {
      const storeState = action?.dataSource?.source === "GLOBAL" ? globalState : action?.dataSource?.source === "REDUX" ? { page: pageStore, layout: layoutStore } : state;
      const clipboardData = action?.dynamicPayload ? getPayload(action, state): action?.dataSource ? getData(action?.dataSource, storeState) : "";

      const text = typeof clipboardData === 'string' ? clipboardData : JSON.stringify(clipboardData);
      
      await navigator.clipboard.writeText(text);
    } catch (error) {
    }
  }

  // const updateGlobalState = (action: updateStateActionInterface, payload: any) => {
  //   setGlobalState((prevState: any) => {
  //     const newState = { ...prevState };

  //     action?.update?.forEach((update) => {
  //       let current = newState;
  //       do {
  //         const { key, fieldName, field } = update;

  //         if (!current[update.key]) {
  //           current[update.key] = {}
  //         }
  //         current = current[update.key];

  //         if (fieldName) {
  //           current[fieldName] = payload;
  //           break;
  //         }

  //         if(!field && !fieldName){
  //           current = payload;
  //           break
  //         }

  //         if (update.field) {
  //           update = update.field
  //         }
  //       } while (update.field && update.field.key);
  //     })
  //     return newState;
  //   })
  // }

  const getPayload = (action: callApiActionInterface | copyClipboardInterface, state: any) => {

    const getDataFromHierarchy = (state: any, hierarchy: updateState) => {
      if (hierarchy?.field) {
        return getDataFromHierarchy(state[hierarchy?.key], hierarchy?.field);
      }

      return state[hierarchy?.key];
    };

    const generateDynamicPayload = (payloadStructure: dynamicPayload[]) => {
      let payload: any = {};

      payloadStructure?.map((structure) => {
        
        const data = structure.fields
        ? generateDynamicPayload(structure.fields)
        : structure.dataSource
          ? getData(
            structure.dataSource,
            structure.dataSource.source === "REDUX"
              ? { page: pageStore, layout: layoutStore }
              : structure.dataSource.source === "GLOBAL" ? fullGlobalState : state, state ? state : globalState, fullGlobalState, { page: pageStore, layout: layoutStore }, state
          )
          : structure?.requireEventValue
            ? state
            : structure.staticValue;
        payload[structure.key] = structure.inArray ? [data] : data;
        //TODO:  This is only the workaround proper solution is still in need 
        //Problem: We are calling two actions on one button click first action to update the state and second is call API with payload which generated
        //by the first action but generateDynamicPayload cant getting latest state.
      });

      return payload;
    };

    const generateStaticPayload = () => {
      return action?.staticPayload;
    };
    const payload = action.dynamicPayload
      ? generateDynamicPayload(action.dynamicPayload)
      : generateStaticPayload();

    return payload;
  };

  const generateExtractedValues = async (keyStructure: any[], payload: any) => {    
      let object: any = {};
    for (const structure of keyStructure) {
      object[structure.key] = await getData(
        structure.dataSource,
        structure.dataSource.source === "REDUX"
          ? { page: pageStore, layout: layoutStore }
          : structure.dataSource.source === "GLOBAL"
            ? globalState
            : payload
      );
    }
    return object;
  };

  const fetchApi = async (action: callApiActionInterface, state: any) => {
    try {
      let response: undefined | Record<any, any>;

      const extractedValues = action?.dynamicParams
      ? await generateExtractedValues(action?.dynamicParams, state)
      : {};
      
      let resolvedEndPoint = action?.dynamicParams
      ? await replacePlaceholders(action?.endpoint, extractedValues)
      : action.endpoint;
      const payloadData = getPayload(action, state);
    
      if (action.method === "GET") {
        response = await get(
          resolvedEndPoint,
          payloadData,
          action.baseUrl
        );
      } else if (action.method === "POST") {

        response = await post(
          resolvedEndPoint,
          payloadData,
          action?.baseUrl
        );
      } else if (action.method === "PUT") {
        response = await put(
          resolvedEndPoint,
          payloadData,
          action?.baseUrl
        );
      } else if (action.method === "DELETE") {
        response = await del(
          resolvedEndPoint,
          payloadData,
          action?.baseUrl
        );
      }

      const actions = action.onResponse ?? [];
      for (let i = 0; i < actions?.length; i++) {
        callAction(
          actions[i],
          actions[i]?.fullResponse ? response?.data: response?.data?.data ? response?.data?.data : response?.data
        );
      }

    } catch (error: any) {
      if(error?.status === 406){
        clearAllCookies()
        callApi(deviceRegisterApi, {})
      }
      
      let {errors, message, data} = error?.response?.data ?? {}

      // --- NEW: handle 460 specifically ---
      if (error?.status === 460) {
        dispatch({type: "SET_REDUX_STATE", payload: {
          action: {
            actionType: "updateReduxState",
            reducer: "layout",
            update: {
              key: "salesUnitDifferErrorModalShow"
            }
          },
          payload: true,
        }});
        dispatch(
          {
            type: "SET_REDUX_STATE", payload: {
            action: {
              actionType: "updateReduxState",
              reducer: "layout",
              update: {
                key: "salesUnitDifferErrorModalData"
              }
            },
            payload: data
            }
          }
        )
      }else

      if(action?.defaultToaster ?? true){
        dispatch({type: "SET_REDUX_STATE", payload: {
          action: {
            actionType: "updateReduxState",
            reducer: "layout",
            update: {
              key: "toaster",
              field: {
                key: "type"
              }
            }
          },
          payload: "error",
        }})
        dispatch(
          {
            type: "SET_REDUX_STATE", payload: {
            action: {
              actionType: "updateReduxState",
              reducer: "layout",
              update: {
                key: "toaster",
                field: {
                  key: "message"
                }
              }
            },
            payload: Object.keys(errors ?? {})?.length ? Object.keys(errors).map(key => errors[key][0]): message,
            }
          }
        )        
      }
      const actions = action.onError ?? [];
      
      
      callAction(
        {
          "actionType": "updateReduxState",
          "reducer":"layout",
          "update": {
            "key": "loader",
            "field": {
              "key": "is_common_loader"
            }
          },
          "value": false
        },
        {}
      );
      for (let i = 0; i < actions?.length; i++) {
        callAction(
          actions[i],
          error?.response?.data ?? {}
        );
      }
    }
  };

  const callApi = (action: callApiActionInterface, state: any) => {

    if(action && Number(action?.timeout ?? 0) > 0){
      let timer = setTimeout(()=>{
        fetchApi(action, state)
      }, action?.timeout); 
      addTimer(timer);
    } else {
      fetchApi(action, state);
    }
  };

  return callAction;
};

export default useAction;
